export default function Subtitle({ style, text }) {
  return (
    <p
      className={`py-5 font-serif leading-5 text-slate-800 font-thin ${style}`}
    >
      {text}
    </p>
  );
}
